var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _polygon, _path569;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreemapchartThumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 953,
    height: 794,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "full",
    viewBox: "0 0 953 794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 953,
    height: 794,
    x: 0,
    y: 0,
    id: 0,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l762.4 0l0 635.2l-762.4 0Z",
    transform: "translate(95.3 79.4)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l366.2435 0l0 443.2467l-366.2435 0Z",
    transform: "translate(95.3 79.4)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l366.2435 0l0 186.9533l-366.2435 0Z",
    transform: "translate(95.3 527.6467)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l228.3152 0l0 271.3472l-228.3152 0Z",
    transform: "translate(466.5435 79.4)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l157.8412 0l0 271.3472l-157.8412 0Z",
    transform: "translate(699.8588 79.4)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l245.3076 0l0 170.8508l-245.3076 0Z",
    transform: "translate(466.5435 355.7472)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l245.3076 0l0 94.5695l-245.3076 0Z",
    transform: "translate(466.5435 531.5979)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l245.3076 0l0 83.4326l-245.3076 0Z",
    transform: "translate(466.5435 631.1674)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l80.1688 0l0 119.6876l-80.1688 0Z",
    transform: "translate(716.8511 355.7472)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l55.6801 0l0 119.6876l-55.6801 0Z",
    transform: "translate(802.0199 355.7472)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l70.5704 0l0 78.3201l-70.5704 0Z",
    transform: "translate(716.8511 480.4347)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l65.2785 0l0 78.3201l-65.2785 0Z",
    transform: "translate(792.4215 480.4347)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l67.9819 0l0 63.9286l-67.9819 0Z",
    transform: "translate(716.8511 563.7549)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.7741 0l0 63.9286l-32.7741 0Z",
    transform: "translate(789.833 563.7549)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l30.0929 0l0 63.9286l-30.0929 0Z",
    transform: "translate(827.6071 563.7549)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l45.6026 0l0 42.3323l-45.6026 0Z",
    transform: "translate(716.8511 632.6835)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l45.6026 0l0 34.5842l-45.6026 0Z",
    transform: "translate(716.8511 680.0158)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l40.0031 0l0 38.7272l-40.0031 0Z",
    transform: "translate(767.4537 632.6835)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l40.0031 0l0 38.1894l-40.0031 0Z",
    transform: "translate(767.4537 676.4106)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.8942 0l0 42.2944l-22.8942 0Z",
    transform: "translate(812.4569 632.6835)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.3489 0l0 42.2944l-17.3489 0Z",
    transform: "translate(840.3511 632.6835)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.1544 0l0 8.7794l-21.1544 0Z",
    transform: "translate(812.4569 679.9778)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.1544 0l0 8.2747l-21.1544 0Z",
    transform: "translate(812.4569 693.7573)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.1544 0l0 7.568l-21.1544 0Z",
    transform: "translate(812.4569 707.032)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l7.0609 0l0 21.5244l-7.0609 0Z",
    transform: "translate(838.6113 679.9778)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l7.0278 0l0 21.5244l-7.0278 0Z",
    transform: "translate(850.6722 679.9778)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l19.0887 0l0 8.0978l-19.0887 0Z",
    transform: "translate(838.6113 706.5022)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l245.3076 0l0 83.4326l-245.3076 0Z",
    transform: "translate(466.5435 631.1674)",
    fill: "#fc8452"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l67.9819 0l0 63.9286l-67.9819 0Z",
    transform: "translate(716.8511 563.7549)",
    fill: "#fac858"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.1544 0l0 8.7794l-21.1544 0Z",
    transform: "translate(812.4569 679.9778)",
    fill: "#fac858"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.1544 0l0 8.2747l-21.1544 0Z",
    transform: "translate(812.4569 693.7573)",
    fill: "#ee6666"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.1544 0l0 7.568l-21.1544 0Z",
    transform: "translate(812.4569 707.032)",
    fill: "#73c0de"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l7.0609 0l0 21.5244l-7.0609 0Z",
    transform: "translate(838.6113 679.9778)",
    fill: "#3ba272"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l7.0278 0l0 21.5244l-7.0278 0Z",
    transform: "translate(850.6722 679.9778)",
    fill: "#fc8452"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l19.0887 0l0 8.0978l-19.0887 0Z",
    transform: "translate(838.6113 706.5022)",
    fill: "#9a60b4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l366.2435 0l0 440.4602l-366.2435 0Z",
    transform: "translate(95.3 79.4)",
    fill: "rgb(102,127,204)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l257.7116 0l0 1.7865l-257.7116 0Z",
    transform: "translate(95.3 520.8602)",
    fill: "rgb(102,127,204)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l107.5319 0l0 1.7865l-107.5319 0Z",
    transform: "translate(354.0116 520.8602)",
    fill: "rgb(102,127,204)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l125.5469 0l0 116.1533l-125.5469 0Z",
    transform: "translate(95.3 527.6467)",
    fill: "rgb(136,200,106)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l125.5469 0l0 69.8l-125.5469 0Z",
    transform: "translate(95.3 644.8)",
    fill: "rgb(136,200,106)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l91.2992 0l0 94.6089l-91.2992 0Z",
    transform: "translate(221.8469 527.6467)",
    fill: "rgb(136,200,106)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l91.2992 0l0 53.7943l-91.2992 0Z",
    transform: "translate(221.8469 623.2556)",
    fill: "rgb(136,200,106)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l91.2992 0l0 36.55l-91.2992 0Z",
    transform: "translate(221.8469 678.05)",
    fill: "rgb(136,200,106)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l50.109 0l0 56.9719l-50.109 0Z",
    transform: "translate(314.1461 527.6467)",
    fill: "rgb(136,200,106)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l49.5332 0l0 56.9719l-49.5332 0Z",
    transform: "translate(365.2551 527.6467)",
    fill: "rgb(136,200,106)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l45.7552 0l0 56.9719l-45.7552 0Z",
    transform: "translate(415.7883 527.6467)",
    fill: "rgb(136,200,106)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l49.4895 0l0 39.0006l-49.4895 0Z",
    transform: "translate(314.1461 585.6185)",
    fill: "rgb(136,200,106)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l49.4895 0l0 31.9459l-49.4895 0Z",
    transform: "translate(314.1461 625.6191)",
    fill: "rgb(136,200,106)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l49.4895 0l0 28.8125l-49.4895 0Z",
    transform: "translate(314.1461 658.565)",
    fill: "rgb(136,200,106)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l49.4895 0l0 26.2225l-49.4895 0Z",
    transform: "translate(314.1461 688.3775)",
    fill: "rgb(136,200,106)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l26.7284 0l0 46.3917l-26.7284 0Z",
    transform: "translate(364.6356 585.6185)",
    fill: "rgb(136,200,106)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.4673 0l0 46.3917l-23.4673 0Z",
    transform: "translate(392.3639 585.6185)",
    fill: "rgb(136,200,106)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.6376 0l0 46.3917l-22.6376 0Z",
    transform: "translate(416.8313 585.6185)",
    fill: "rgb(136,200,106)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.0746 0l0 46.3917l-21.0746 0Z",
    transform: "translate(440.4689 585.6185)",
    fill: "rgb(136,200,106)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l35.1515 0l0 26.3824l-35.1515 0Z",
    transform: "translate(364.6356 633.0102)",
    fill: "rgb(136,200,106)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l35.1515 0l0 20.0079l-35.1515 0Z",
    transform: "translate(364.6356 660.3926)",
    fill: "rgb(136,200,106)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l35.1515 0l0 18.6799l-35.1515 0Z",
    transform: "translate(364.6356 681.4005)",
    fill: "rgb(136,200,106)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l35.1515 0l0 13.5196l-35.1515 0Z",
    transform: "translate(364.6356 701.0804)",
    fill: "rgb(136,200,106)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.4177 0l0 28.4377l-15.4177 0Z",
    transform: "translate(400.7871 633.0102)",
    fill: "rgb(136,200,106)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14.5634 0l0 28.4377l-14.5634 0Z",
    transform: "translate(417.2047 633.0102)",
    fill: "rgb(136,200,106)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14.377 0l0 28.4377l-14.377 0Z",
    transform: "translate(432.7681 633.0102)",
    fill: "rgb(136,200,106)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.3985 0l0 28.4377l-13.3985 0Z",
    transform: "translate(448.1451 633.0102)",
    fill: "rgb(136,200,106)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.0888 0l0 17.0606l-22.0888 0Z",
    transform: "translate(400.7871 662.4479)",
    fill: "rgb(136,200,106)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.0888 0l0 16.9616l-22.0888 0Z",
    transform: "translate(400.7871 680.5085)",
    fill: "rgb(136,200,106)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.0888 0l0 16.1299l-22.0888 0Z",
    transform: "translate(400.7871 698.4701)",
    fill: "rgb(136,200,106)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l12.2766 0l0 27.7223l-12.2766 0Z",
    transform: "translate(423.8758 662.4479)",
    fill: "rgb(136,200,106)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l11.7672 0l0 27.7223l-11.7672 0Z",
    transform: "translate(437.1524 662.4479)",
    fill: "rgb(136,200,106)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l11.6239 0l0 27.7223l-11.6239 0Z",
    transform: "translate(449.9196 662.4479)",
    fill: "rgb(136,200,106)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.3524 0l0 11.4752l-25.3524 0Z",
    transform: "translate(423.8758 691.1701)",
    fill: "rgb(136,200,106)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.3524 0l0 10.9547l-25.3524 0Z",
    transform: "translate(423.8758 703.6453)",
    fill: "rgb(136,200,106)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l11.3153 0l0 23.4299l-11.3153 0Z",
    transform: "translate(450.2283 691.1701)",
    fill: "rgb(136,200,106)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l122.4273 0l0 108.8164l-122.4273 0Z",
    transform: "translate(466.5435 79.4)",
    fill: "rgb(249,190,57)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l72.6555 0l0 108.8164l-72.6555 0Z",
    transform: "translate(589.9708 79.4)",
    fill: "rgb(249,190,57)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l31.2325 0l0 108.8164l-31.2325 0Z",
    transform: "translate(663.6262 79.4)",
    fill: "rgb(249,190,57)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l65.9707 0l0 46.0088l-65.9707 0Z",
    transform: "translate(466.5435 189.2164)",
    fill: "rgb(249,190,57)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l65.9707 0l0 44.6522l-65.9707 0Z",
    transform: "translate(466.5435 236.2252)",
    fill: "rgb(249,190,57)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l65.9707 0l0 36.3652l-65.9707 0Z",
    transform: "translate(466.5435 281.8774)",
    fill: "rgb(249,190,57)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l65.9707 0l0 31.5046l-65.9707 0Z",
    transform: "translate(466.5435 319.2426)",
    fill: "rgb(249,190,57)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.0711 0l0 55.2513l-37.0711 0Z",
    transform: "translate(533.5142 189.2164)",
    fill: "rgb(249,190,57)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l36.2036 0l0 55.2513l-36.2036 0Z",
    transform: "translate(571.5853 189.2164)",
    fill: "rgb(249,190,57)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l33.4255 0l0 55.2513l-33.4255 0Z",
    transform: "translate(608.7889 189.2164)",
    fill: "rgb(249,190,57)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l26.7989 0l0 55.2513l-26.7989 0Z",
    transform: "translate(643.2145 189.2164)",
    fill: "rgb(249,190,57)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.8455 0l0 55.2513l-23.8455 0Z",
    transform: "translate(671.0133 189.2164)",
    fill: "rgb(249,190,57)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l42.6123 0l0 28.1173l-42.6123 0Z",
    transform: "translate(533.5142 245.4677)",
    fill: "rgb(249,190,57)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l42.6123 0l0 27.5102l-42.6123 0Z",
    transform: "translate(533.5142 274.585)",
    fill: "rgb(249,190,57)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l42.6123 0l0 24.2723l-42.6123 0Z",
    transform: "translate(533.5142 303.0953)",
    fill: "rgb(249,190,57)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l42.6123 0l0 22.3796l-42.6123 0Z",
    transform: "translate(533.5142 328.3676)",
    fill: "rgb(249,190,57)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.6395 0l0 24.6226l-37.6395 0Z",
    transform: "translate(577.1265 245.4677)",
    fill: "rgb(249,190,57)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.6395 0l0 21.4248l-37.6395 0Z",
    transform: "translate(577.1265 271.0903)",
    fill: "rgb(249,190,57)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.6395 0l0 19.7185l-37.6395 0Z",
    transform: "translate(577.1265 293.5152)",
    fill: "rgb(249,190,57)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.6395 0l0 17.9986l-37.6395 0Z",
    transform: "translate(577.1265 314.2336)",
    fill: "rgb(249,190,57)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.6395 0l0 17.5149l-37.6395 0Z",
    transform: "translate(577.1265 333.2322)",
    fill: "rgb(249,190,57)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l20.0367 0l0 31.5269l-20.0367 0Z",
    transform: "translate(615.766 245.4677)",
    fill: "rgb(249,190,57)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l18.8556 0l0 31.5269l-18.8556 0Z",
    transform: "translate(636.8028 245.4677)",
    fill: "rgb(249,190,57)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l18.7598 0l0 31.5269l-18.7598 0Z",
    transform: "translate(656.6584 245.4677)",
    fill: "rgb(249,190,57)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l18.4406 0l0 31.5269l-18.4406 0Z",
    transform: "translate(676.4182 245.4677)",
    fill: "rgb(249,190,57)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.9446 0l0 18.5958l-29.9446 0Z",
    transform: "translate(615.766 277.9946)",
    fill: "rgb(249,190,57)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.9446 0l0 18.1764l-29.9446 0Z",
    transform: "translate(615.766 297.5903)",
    fill: "rgb(249,190,57)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.9446 0l0 16.8174l-29.9446 0Z",
    transform: "translate(615.766 316.7667)",
    fill: "rgb(249,190,57)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.9446 0l0 16.1631l-29.9446 0Z",
    transform: "translate(615.766 334.5841)",
    fill: "rgb(249,190,57)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.715 0l0 28.7461l-16.715 0Z",
    transform: "translate(646.7106 277.9946)",
    fill: "rgb(249,190,57)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.2664 0l0 28.7461l-15.2664 0Z",
    transform: "translate(664.4256 277.9946)",
    fill: "rgb(249,190,57)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14.1668 0l0 28.7461l-14.1668 0Z",
    transform: "translate(680.692 277.9946)",
    fill: "rgb(249,190,57)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.4263 0l0 15.2667l-25.4263 0Z",
    transform: "translate(646.7106 307.7407)",
    fill: "rgb(249,190,57)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.4263 0l0 12.9288l-25.4263 0Z",
    transform: "translate(646.7106 324.0074)",
    fill: "rgb(249,190,57)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.4263 0l0 12.811l-25.4263 0Z",
    transform: "translate(646.7106 337.9362)",
    fill: "rgb(249,190,57)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l10.4639 0l0 29.2516l-10.4639 0Z",
    transform: "translate(673.1369 307.7407)",
    fill: "rgb(249,190,57)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l10.258 0l0 29.2516l-10.258 0Z",
    transform: "translate(684.6008 307.7407)",
    fill: "rgb(249,190,57)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.7219 0l0 12.7549l-21.7219 0Z",
    transform: "translate(673.1369 337.9923)",
    fill: "rgb(249,190,57)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l157.8412 0l0 128.077l-157.8412 0Z",
    transform: "translate(699.8588 79.4)",
    fill: "rgb(235,71,71)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l74.6145 0l0 54.6669l-74.6145 0Z",
    transform: "translate(699.8588 208.477)",
    fill: "rgb(235,71,71)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l74.6145 0l0 43.6374l-74.6145 0Z",
    transform: "translate(699.8588 264.1439)",
    fill: "rgb(235,71,71)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l74.6145 0l0 41.9659l-74.6145 0Z",
    transform: "translate(699.8588 308.7813)",
    fill: "rgb(235,71,71)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l36.7256 0l0 45.9801l-36.7256 0Z",
    transform: "translate(775.4733 208.477)",
    fill: "rgb(235,71,71)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.9072 0l0 45.9801l-22.9072 0Z",
    transform: "translate(813.1989 208.477)",
    fill: "rgb(235,71,71)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l20.5939 0l0 45.9801l-20.5939 0Z",
    transform: "translate(837.1061 208.477)",
    fill: "rgb(235,71,71)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.1822 0l0 39.8826l-23.1822 0Z",
    transform: "translate(775.4733 255.4571)",
    fill: "rgb(235,71,71)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l20.7933 0l0 39.8826l-20.7933 0Z",
    transform: "translate(799.6555 255.4571)",
    fill: "rgb(235,71,71)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l18.3809 0l0 39.8826l-18.3809 0Z",
    transform: "translate(821.4488 255.4571)",
    fill: "rgb(235,71,71)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.8703 0l0 39.8826l-16.8703 0Z",
    transform: "translate(840.8297 255.4571)",
    fill: "rgb(235,71,71)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.4018 0l0 19.0087l-27.4018 0Z",
    transform: "translate(775.4733 296.3397)",
    fill: "rgb(235,71,71)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.4018 0l0 17.0028l-27.4018 0Z",
    transform: "translate(775.4733 316.3484)",
    fill: "rgb(235,71,71)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.4018 0l0 16.396l-27.4018 0Z",
    transform: "translate(775.4733 334.3512)",
    fill: "rgb(235,71,71)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.921 0l0 21.9751l-17.921 0Z",
    transform: "translate(803.8751 296.3397)",
    fill: "rgb(235,71,71)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.2541 0l0 21.9751l-17.2541 0Z",
    transform: "translate(822.796 296.3397)",
    fill: "rgb(235,71,71)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.6498 0l0 21.9751l-16.6498 0Z",
    transform: "translate(841.0502 296.3397)",
    fill: "rgb(235,71,71)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.2535 0l0 15.305l-23.2535 0Z",
    transform: "translate(803.8751 319.3148)",
    fill: "rgb(235,71,71)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.2535 0l0 15.1274l-23.2535 0Z",
    transform: "translate(803.8751 335.6198)",
    fill: "rgb(235,71,71)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.7781 0l0 21.4568l-15.7781 0Z",
    transform: "translate(828.1285 319.3148)",
    fill: "rgb(235,71,71)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l12.7934 0l0 21.4568l-12.7934 0Z",
    transform: "translate(844.9066 319.3148)",
    fill: "rgb(235,71,71)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.5715 0l0 8.9756l-29.5715 0Z",
    transform: "translate(828.1285 341.7716)",
    fill: "rgb(235,71,71)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l100.314 0l0 85.0534l-100.314 0Z",
    transform: "translate(466.5435 355.7472)",
    fill: "rgb(90,181,216)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l100.314 0l0 84.7974l-100.314 0Z",
    transform: "translate(466.5435 441.8006)",
    fill: "rgb(90,181,216)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l44.148 0l0 65.07l-44.148 0Z",
    transform: "translate(567.8576 355.7472)",
    fill: "rgb(90,181,216)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l39.6246 0l0 65.07l-39.6246 0Z",
    transform: "translate(613.0056 355.7472)",
    fill: "rgb(90,181,216)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.6588 0l0 65.07l-32.6588 0Z",
    transform: "translate(653.6302 355.7472)",
    fill: "rgb(90,181,216)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l24.5622 0l0 65.07l-24.5622 0Z",
    transform: "translate(687.289 355.7472)",
    fill: "rgb(90,181,216)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l48.703 0l0 28.2925l-48.703 0Z",
    transform: "translate(567.8576 421.8172)",
    fill: "rgb(90,181,216)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l48.703 0l0 26.3717l-48.703 0Z",
    transform: "translate(567.8576 451.1097)",
    fill: "rgb(90,181,216)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l48.703 0l0 24.2003l-48.703 0Z",
    transform: "translate(567.8576 478.4814)",
    fill: "rgb(90,181,216)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l48.703 0l0 22.9163l-48.703 0Z",
    transform: "translate(567.8576 503.6817)",
    fill: "rgb(90,181,216)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.5721 0l0 34.1913l-32.5721 0Z",
    transform: "translate(617.5605 421.8172)",
    fill: "rgb(90,181,216)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.5583 0l0 34.1913l-21.5583 0Z",
    transform: "translate(651.1327 421.8172)",
    fill: "rgb(90,181,216)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l20.4083 0l0 34.1913l-20.4083 0Z",
    transform: "translate(673.691 421.8172)",
    fill: "rgb(90,181,216)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.7518 0l0 34.1913l-16.7518 0Z",
    transform: "translate(695.0993 421.8172)",
    fill: "rgb(90,181,216)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l33.4072 0l0 17.1262l-33.4072 0Z",
    transform: "translate(617.5605 457.0085)",
    fill: "rgb(90,181,216)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l33.4072 0l0 16.9301l-33.4072 0Z",
    transform: "translate(617.5605 475.1346)",
    fill: "rgb(90,181,216)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l33.4072 0l0 16.4476l-33.4072 0Z",
    transform: "translate(617.5605 493.0648)",
    fill: "rgb(90,181,216)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l33.4072 0l0 16.0856l-33.4072 0Z",
    transform: "translate(617.5605 510.5123)",
    fill: "rgb(90,181,216)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.402 0l0 30.4384l-17.402 0Z",
    transform: "translate(651.9678 457.0085)",
    fill: "rgb(90,181,216)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.8866 0l0 30.4384l-13.8866 0Z",
    transform: "translate(670.3697 457.0085)",
    fill: "rgb(90,181,216)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.7546 0l0 30.4384l-13.7546 0Z",
    transform: "translate(685.2564 457.0085)",
    fill: "rgb(90,181,216)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l11.8401 0l0 30.4384l-11.8401 0Z",
    transform: "translate(700.011 457.0085)",
    fill: "rgb(90,181,216)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.5598 0l0 13.098l-27.5598 0Z",
    transform: "translate(651.9678 488.4469)",
    fill: "rgb(90,181,216)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.5598 0l0 12.5166l-27.5598 0Z",
    transform: "translate(651.9678 502.5449)",
    fill: "rgb(90,181,216)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.5598 0l0 10.5364l-27.5598 0Z",
    transform: "translate(651.9678 516.0616)",
    fill: "rgb(90,181,216)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.1746 0l0 19.2417l-15.1746 0Z",
    transform: "translate(680.5275 488.4469)",
    fill: "rgb(90,181,216)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.149 0l0 19.2417l-15.149 0Z",
    transform: "translate(696.7021 488.4469)",
    fill: "rgb(90,181,216)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.4362 0l0 17.9094l-15.4362 0Z",
    transform: "translate(680.5275 508.6886)",
    fill: "rgb(90,181,216)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14.8874 0l0 17.9094l-14.8874 0Z",
    transform: "translate(696.9637 508.6886)",
    fill: "rgb(90,181,216)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l113.7589 0l0 94.5695l-113.7589 0Z",
    transform: "translate(466.5435 531.5979)",
    fill: "rgb(105,201,156)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l52.8277 0l0 49.6146l-52.8277 0Z",
    transform: "translate(581.3024 531.5979)",
    fill: "rgb(105,201,156)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l52.8277 0l0 43.9549l-52.8277 0Z",
    transform: "translate(581.3024 582.2126)",
    fill: "rgb(105,201,156)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l28.9464 0l0 36.71l-28.9464 0Z",
    transform: "translate(635.1301 531.5979)",
    fill: "rgb(105,201,156)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.9372 0l0 36.71l-22.9372 0Z",
    transform: "translate(665.0765 531.5979)",
    fill: "rgb(105,201,156)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.8374 0l0 36.71l-22.8374 0Z",
    transform: "translate(689.0137 531.5979)",
    fill: "rgb(105,201,156)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.1198 0l0 21.2864l-32.1198 0Z",
    transform: "translate(635.1301 569.3079)",
    fill: "rgb(105,201,156)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.1198 0l0 18.0925l-32.1198 0Z",
    transform: "translate(635.1301 591.5943)",
    fill: "rgb(105,201,156)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.1198 0l0 15.4806l-32.1198 0Z",
    transform: "translate(635.1301 610.6868)",
    fill: "rgb(105,201,156)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.6677 0l0 31.5506l-15.6677 0Z",
    transform: "translate(668.2499 569.3079)",
    fill: "rgb(105,201,156)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.6601 0l0 31.5506l-13.6601 0Z",
    transform: "translate(684.9176 569.3079)",
    fill: "rgb(105,201,156)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l12.2735 0l0 31.5506l-12.2735 0Z",
    transform: "translate(699.5776 569.3079)",
    fill: "rgb(105,201,156)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.4091 0l0 12.4043l-29.4091 0Z",
    transform: "translate(668.2499 601.8585)",
    fill: "rgb(105,201,156)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.4091 0l0 10.9046l-29.4091 0Z",
    transform: "translate(668.2499 615.2628)",
    fill: "rgb(105,201,156)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.1921 0l0 24.3089l-13.1921 0Z",
    transform: "translate(698.659 601.8585)",
    fill: "rgb(105,201,156)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l54.3335 0l0 63.9891l-54.3335 0Z",
    transform: "translate(716.8511 355.7472)",
    fill: "rgb(167,116,190)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l24.8353 0l0 63.9891l-24.8353 0Z",
    transform: "translate(772.1846 355.7472)",
    fill: "rgb(167,116,190)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l40.6126 0l0 29.5333l-40.6126 0Z",
    transform: "translate(716.8511 420.7363)",
    fill: "rgb(167,116,190)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l40.6126 0l0 24.1652l-40.6126 0Z",
    transform: "translate(716.8511 451.2695)",
    fill: "rgb(167,116,190)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.6101 0l0 43.1157l-21.6101 0Z",
    transform: "translate(758.4638 420.7363)",
    fill: "rgb(167,116,190)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.946 0l0 43.1157l-15.946 0Z",
    transform: "translate(781.0739 420.7363)",
    fill: "rgb(167,116,190)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l38.5562 0l0 10.5828l-38.5562 0Z",
    transform: "translate(758.4638 464.8519)",
    fill: "rgb(167,116,190)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l55.6801 0l0 93.7798l-55.6801 0Z",
    transform: "translate(802.0199 355.7472)",
    fill: "rgb(227,79,187)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.9681 0l0 24.9077l-32.9681 0Z",
    transform: "translate(802.0199 450.527)",
    fill: "rgb(227,79,187)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.712 0l0 24.9077l-21.712 0Z",
    transform: "translate(835.988 450.527)",
    fill: "rgb(227,79,187)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l45.9509 0l0 58.8186l-45.9509 0Z",
    transform: "translate(716.8511 480.4347)",
    fill: "rgb(102,127,204)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.6195 0l0 58.8186l-23.6195 0Z",
    transform: "translate(763.802 480.4347)",
    fill: "rgb(102,127,204)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l70.5704 0l0 18.5016l-70.5704 0Z",
    transform: "translate(716.8511 540.2533)",
    fill: "rgb(102,127,204)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.7085 0l0 41.6787l-25.7085 0Z",
    transform: "translate(792.4215 480.4347)",
    fill: "rgb(136,200,106)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.213 0l0 41.6787l-21.213 0Z",
    transform: "translate(819.13 480.4347)",
    fill: "rgb(136,200,106)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.3569 0l0 41.6787l-16.3569 0Z",
    transform: "translate(841.3431 480.4347)",
    fill: "rgb(136,200,106)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l36.6614 0l0 17.7975l-36.6614 0Z",
    transform: "translate(792.4215 523.1134)",
    fill: "rgb(136,200,106)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l36.6614 0l0 16.844l-36.6614 0Z",
    transform: "translate(792.4215 541.9109)",
    fill: "rgb(136,200,106)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.7846 0l0 35.6414l-13.7846 0Z",
    transform: "translate(830.0829 523.1134)",
    fill: "rgb(136,200,106)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l12.8325 0l0 35.6414l-12.8325 0Z",
    transform: "translate(844.8675 523.1134)",
    fill: "rgb(136,200,106)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.4737 0l0 45.6347l-17.4737 0Z",
    transform: "translate(789.833 563.7549)",
    fill: "rgb(235,71,71)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14.3004 0l0 45.6347l-14.3004 0Z",
    transform: "translate(808.3067 563.7549)",
    fill: "rgb(235,71,71)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.9143 0l0 17.2939l-15.9143 0Z",
    transform: "translate(789.833 610.3896)",
    fill: "rgb(235,71,71)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.8598 0l0 17.2939l-15.8598 0Z",
    transform: "translate(806.7473 610.3896)",
    fill: "rgb(235,71,71)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l30.0929 0l0 63.9286l-30.0929 0Z",
    transform: "translate(827.6071 563.7549)",
    fill: "rgb(90,181,216)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l45.6026 0l0 42.3323l-45.6026 0Z",
    transform: "translate(716.8511 632.6835)",
    fill: "rgb(105,201,156)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l45.6026 0l0 34.5842l-45.6026 0Z",
    transform: "translate(716.8511 680.0158)",
    fill: "rgb(252,112,54)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l40.0031 0l0 38.7272l-40.0031 0Z",
    transform: "translate(767.4537 632.6835)",
    fill: "rgb(167,116,190)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l40.0031 0l0 38.1894l-40.0031 0Z",
    transform: "translate(767.4537 676.4106)",
    fill: "rgb(227,79,187)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.8942 0l0 26.8598l-22.8942 0Z",
    transform: "translate(812.4569 632.6835)",
    fill: "rgb(102,127,204)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.8942 0l0 14.4345l-22.8942 0Z",
    transform: "translate(812.4569 660.5433)",
    fill: "rgb(102,127,204)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.3489 0l0 21.2201l-17.3489 0Z",
    transform: "translate(840.3511 632.6835)",
    fill: "rgb(136,200,106)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.3489 0l0 20.0742l-17.3489 0Z",
    transform: "translate(840.3511 654.9036)",
    fill: "rgb(136,200,106)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l24.8353 0l0 63.9891l-24.8353 0Z",
    transform: "translate(772.1846 355.7472)",
    fill: "#9a60b4"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l40.6126 0l0 29.5333l-40.6126 0Z",
    transform: "translate(716.8511 420.7363)",
    fill: "#9a60b4"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l40.6126 0l0 24.1652l-40.6126 0Z",
    transform: "translate(716.8511 451.2695)",
    fill: "#9a60b4"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.946 0l0 43.1157l-15.946 0Z",
    transform: "translate(781.0739 420.7363)",
    fill: "#9a60b4"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l38.5562 0l0 10.5828l-38.5562 0Z",
    transform: "translate(758.4638 464.8519)",
    fill: "#9a60b4"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.9681 0l0 24.9077l-32.9681 0Z",
    transform: "translate(802.0199 450.527)",
    fill: "#ea7ccc"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l218.1905 0l0 307.5572l-218.1905 0Z",
    transform: "translate(95.3 79.4)",
    fill: "#fff"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l147.053 0l0 307.5572l-147.053 0Z",
    transform: "translate(314.4905 79.4)",
    fill: "#fff"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l339.9816 0l0 131.903l-339.9816 0Z",
    transform: "translate(95.3 387.9572)",
    fill: "#fff"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.2619 0l0 119.8485l-25.2619 0Z",
    transform: "translate(436.2816 387.9572)",
    fill: "#fff"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.2619 0l0 11.0545l-25.2619 0Z",
    transform: "translate(436.2816 508.8057)",
    fill: "#fff"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l257.7116 0l0 1.7865l-257.7116 0Z",
    transform: "translate(95.3 520.8602)",
    fill: "#fff"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l107.5319 0l0 1.7865l-107.5319 0Z",
    transform: "translate(354.0116 520.8602)",
    fill: "#fff"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l125.5469 0l0 116.1533l-125.5469 0Z",
    transform: "translate(95.3 527.6467)",
    fill: "#fff"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l125.5469 0l0 69.8l-125.5469 0Z",
    transform: "translate(95.3 644.8)",
    fill: "#fff"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l91.2992 0l0 94.6089l-91.2992 0Z",
    transform: "translate(221.8469 527.6467)",
    fill: "#fff"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l91.2992 0l0 53.7943l-91.2992 0Z",
    transform: "translate(221.8469 623.2556)",
    fill: "#fff"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l91.2992 0l0 36.55l-91.2992 0Z",
    transform: "translate(221.8469 678.05)",
    fill: "#fff"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l50.109 0l0 56.9719l-50.109 0Z",
    transform: "translate(314.1461 527.6467)",
    fill: "#fff"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l49.5332 0l0 56.9719l-49.5332 0Z",
    transform: "translate(365.2551 527.6467)",
    fill: "#fff"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l45.7552 0l0 56.9719l-45.7552 0Z",
    transform: "translate(415.7883 527.6467)",
    fill: "#fff"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l49.4895 0l0 39.0006l-49.4895 0Z",
    transform: "translate(314.1461 585.6185)",
    fill: "#fff"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l49.4895 0l0 31.9459l-49.4895 0Z",
    transform: "translate(314.1461 625.6191)",
    fill: "#fff"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l49.4895 0l0 28.8125l-49.4895 0Z",
    transform: "translate(314.1461 658.565)",
    fill: "#fff"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l49.4895 0l0 26.2225l-49.4895 0Z",
    transform: "translate(314.1461 688.3775)",
    fill: "#fff"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l26.7284 0l0 46.3917l-26.7284 0Z",
    transform: "translate(364.6356 585.6185)",
    fill: "#fff"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.4673 0l0 46.3917l-23.4673 0Z",
    transform: "translate(392.3639 585.6185)",
    fill: "#fff"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.6376 0l0 46.3917l-22.6376 0Z",
    transform: "translate(416.8313 585.6185)",
    fill: "#fff"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.0746 0l0 46.3917l-21.0746 0Z",
    transform: "translate(440.4689 585.6185)",
    fill: "#fff"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l35.1515 0l0 26.3824l-35.1515 0Z",
    transform: "translate(364.6356 633.0102)",
    fill: "#fff"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l35.1515 0l0 20.0079l-35.1515 0Z",
    transform: "translate(364.6356 660.3926)",
    fill: "#fff"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l35.1515 0l0 18.6799l-35.1515 0Z",
    transform: "translate(364.6356 681.4005)",
    fill: "#fff"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l35.1515 0l0 13.5196l-35.1515 0Z",
    transform: "translate(364.6356 701.0804)",
    fill: "#fff"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.4177 0l0 28.4377l-15.4177 0Z",
    transform: "translate(400.7871 633.0102)",
    fill: "#fff"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14.5634 0l0 28.4377l-14.5634 0Z",
    transform: "translate(417.2047 633.0102)",
    fill: "#fff"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14.377 0l0 28.4377l-14.377 0Z",
    transform: "translate(432.7681 633.0102)",
    fill: "#fff"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.3985 0l0 28.4377l-13.3985 0Z",
    transform: "translate(448.1451 633.0102)",
    fill: "#fff"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.0888 0l0 17.0606l-22.0888 0Z",
    transform: "translate(400.7871 662.4479)",
    fill: "#fff"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.0888 0l0 16.9616l-22.0888 0Z",
    transform: "translate(400.7871 680.5085)",
    fill: "#fff"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.0888 0l0 16.1299l-22.0888 0Z",
    transform: "translate(400.7871 698.4701)",
    fill: "#fff"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l12.2766 0l0 27.7223l-12.2766 0Z",
    transform: "translate(423.8758 662.4479)",
    fill: "#fff"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l11.7672 0l0 27.7223l-11.7672 0Z",
    transform: "translate(437.1524 662.4479)",
    fill: "#fff"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l11.6239 0l0 27.7223l-11.6239 0Z",
    transform: "translate(449.9196 662.4479)",
    fill: "#fff"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.3524 0l0 11.4752l-25.3524 0Z",
    transform: "translate(423.8758 691.1701)",
    fill: "#fff"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.3524 0l0 10.9547l-25.3524 0Z",
    transform: "translate(423.8758 703.6453)",
    fill: "#fff"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l11.3153 0l0 23.4299l-11.3153 0Z",
    transform: "translate(450.2283 691.1701)",
    fill: "#fff"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l122.4273 0l0 108.8164l-122.4273 0Z",
    transform: "translate(466.5435 79.4)",
    fill: "#fff"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l72.6555 0l0 108.8164l-72.6555 0Z",
    transform: "translate(589.9708 79.4)",
    fill: "#fff"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l31.2325 0l0 108.8164l-31.2325 0Z",
    transform: "translate(663.6262 79.4)",
    fill: "#fff"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l65.9707 0l0 46.0088l-65.9707 0Z",
    transform: "translate(466.5435 189.2164)",
    fill: "#fff"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l65.9707 0l0 44.6522l-65.9707 0Z",
    transform: "translate(466.5435 236.2252)",
    fill: "#fff"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l65.9707 0l0 36.3652l-65.9707 0Z",
    transform: "translate(466.5435 281.8774)",
    fill: "#fff"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l65.9707 0l0 31.5046l-65.9707 0Z",
    transform: "translate(466.5435 319.2426)",
    fill: "#fff"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.0711 0l0 55.2513l-37.0711 0Z",
    transform: "translate(533.5142 189.2164)",
    fill: "#fff"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l36.2036 0l0 55.2513l-36.2036 0Z",
    transform: "translate(571.5853 189.2164)",
    fill: "#fff"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l33.4255 0l0 55.2513l-33.4255 0Z",
    transform: "translate(608.7889 189.2164)",
    fill: "#fff"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l26.7989 0l0 55.2513l-26.7989 0Z",
    transform: "translate(643.2145 189.2164)",
    fill: "#fff"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.8455 0l0 55.2513l-23.8455 0Z",
    transform: "translate(671.0133 189.2164)",
    fill: "#fff"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l42.6123 0l0 28.1173l-42.6123 0Z",
    transform: "translate(533.5142 245.4677)",
    fill: "#fff"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l42.6123 0l0 27.5102l-42.6123 0Z",
    transform: "translate(533.5142 274.585)",
    fill: "#fff"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l42.6123 0l0 24.2723l-42.6123 0Z",
    transform: "translate(533.5142 303.0953)",
    fill: "#fff"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l42.6123 0l0 22.3796l-42.6123 0Z",
    transform: "translate(533.5142 328.3676)",
    fill: "#fff"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.6395 0l0 24.6226l-37.6395 0Z",
    transform: "translate(577.1265 245.4677)",
    fill: "#fff"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.6395 0l0 21.4248l-37.6395 0Z",
    transform: "translate(577.1265 271.0903)",
    fill: "#fff"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.6395 0l0 19.7185l-37.6395 0Z",
    transform: "translate(577.1265 293.5152)",
    fill: "#fff"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.6395 0l0 17.9986l-37.6395 0Z",
    transform: "translate(577.1265 314.2336)",
    fill: "#fff"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.6395 0l0 17.5149l-37.6395 0Z",
    transform: "translate(577.1265 333.2322)",
    fill: "#fff"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l20.0367 0l0 31.5269l-20.0367 0Z",
    transform: "translate(615.766 245.4677)",
    fill: "#fff"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l18.8556 0l0 31.5269l-18.8556 0Z",
    transform: "translate(636.8028 245.4677)",
    fill: "#fff"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l18.7598 0l0 31.5269l-18.7598 0Z",
    transform: "translate(656.6584 245.4677)",
    fill: "#fff"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l18.4406 0l0 31.5269l-18.4406 0Z",
    transform: "translate(676.4182 245.4677)",
    fill: "#fff"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.9446 0l0 18.5958l-29.9446 0Z",
    transform: "translate(615.766 277.9946)",
    fill: "#fff"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.9446 0l0 18.1764l-29.9446 0Z",
    transform: "translate(615.766 297.5903)",
    fill: "#fff"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.9446 0l0 16.8174l-29.9446 0Z",
    transform: "translate(615.766 316.7667)",
    fill: "#fff"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.9446 0l0 16.1631l-29.9446 0Z",
    transform: "translate(615.766 334.5841)",
    fill: "#fff"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.715 0l0 28.7461l-16.715 0Z",
    transform: "translate(646.7106 277.9946)",
    fill: "#fff"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.2664 0l0 28.7461l-15.2664 0Z",
    transform: "translate(664.4256 277.9946)",
    fill: "#fff"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14.1668 0l0 28.7461l-14.1668 0Z",
    transform: "translate(680.692 277.9946)",
    fill: "#fff"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.4263 0l0 15.2667l-25.4263 0Z",
    transform: "translate(646.7106 307.7407)",
    fill: "#fff"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.4263 0l0 12.9288l-25.4263 0Z",
    transform: "translate(646.7106 324.0074)",
    fill: "#fff"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.4263 0l0 12.811l-25.4263 0Z",
    transform: "translate(646.7106 337.9362)",
    fill: "#fff"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l10.4639 0l0 29.2516l-10.4639 0Z",
    transform: "translate(673.1369 307.7407)",
    fill: "#fff"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l10.258 0l0 29.2516l-10.258 0Z",
    transform: "translate(684.6008 307.7407)",
    fill: "#fff"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.7219 0l0 12.7549l-21.7219 0Z",
    transform: "translate(673.1369 337.9923)",
    fill: "#fff"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l157.8412 0l0 128.077l-157.8412 0Z",
    transform: "translate(699.8588 79.4)",
    fill: "#fff"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l74.6145 0l0 54.6669l-74.6145 0Z",
    transform: "translate(699.8588 208.477)",
    fill: "#fff"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l74.6145 0l0 43.6374l-74.6145 0Z",
    transform: "translate(699.8588 264.1439)",
    fill: "#fff"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l74.6145 0l0 41.9659l-74.6145 0Z",
    transform: "translate(699.8588 308.7813)",
    fill: "#fff"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l20.2395 0l0 45.9801l-20.2395 0Z",
    transform: "translate(775.4733 208.477)",
    fill: "#fff"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.4861 0l0 45.9801l-15.4861 0Z",
    transform: "translate(796.7128 208.477)",
    fill: "#fff"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.9072 0l0 45.9801l-22.9072 0Z",
    transform: "translate(813.1989 208.477)",
    fill: "#fff"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l20.5939 0l0 45.9801l-20.5939 0Z",
    transform: "translate(837.1061 208.477)",
    fill: "#fff"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.1822 0l0 39.8826l-23.1822 0Z",
    transform: "translate(775.4733 255.4571)",
    fill: "#fff"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l20.7933 0l0 39.8826l-20.7933 0Z",
    transform: "translate(799.6555 255.4571)",
    fill: "#fff"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l18.3809 0l0 39.8826l-18.3809 0Z",
    transform: "translate(821.4488 255.4571)",
    fill: "#fff"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.8703 0l0 39.8826l-16.8703 0Z",
    transform: "translate(840.8297 255.4571)",
    fill: "#fff"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.4018 0l0 19.0087l-27.4018 0Z",
    transform: "translate(775.4733 296.3397)",
    fill: "#fff"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.4018 0l0 17.0028l-27.4018 0Z",
    transform: "translate(775.4733 316.3484)",
    fill: "#fff"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.4018 0l0 16.396l-27.4018 0Z",
    transform: "translate(775.4733 334.3512)",
    fill: "#fff"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.921 0l0 21.9751l-17.921 0Z",
    transform: "translate(803.8751 296.3397)",
    fill: "#fff"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.2541 0l0 21.9751l-17.2541 0Z",
    transform: "translate(822.796 296.3397)",
    fill: "#fff"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.6498 0l0 21.9751l-16.6498 0Z",
    transform: "translate(841.0502 296.3397)",
    fill: "#fff"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.2535 0l0 15.305l-23.2535 0Z",
    transform: "translate(803.8751 319.3148)",
    fill: "#fff"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.2535 0l0 15.1274l-23.2535 0Z",
    transform: "translate(803.8751 335.6198)",
    fill: "#fff"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.7781 0l0 21.4568l-15.7781 0Z",
    transform: "translate(828.1285 319.3148)",
    fill: "#fff"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l12.7934 0l0 21.4568l-12.7934 0Z",
    transform: "translate(844.9066 319.3148)",
    fill: "#fff"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.5715 0l0 8.9756l-29.5715 0Z",
    transform: "translate(828.1285 341.7716)",
    fill: "#fff"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l100.314 0l0 85.0534l-100.314 0Z",
    transform: "translate(466.5435 355.7472)",
    fill: "#fff"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l100.314 0l0 84.7974l-100.314 0Z",
    transform: "translate(466.5435 441.8006)",
    fill: "#fff"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l44.148 0l0 65.07l-44.148 0Z",
    transform: "translate(567.8576 355.7472)",
    fill: "#fff"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l39.6246 0l0 65.07l-39.6246 0Z",
    transform: "translate(613.0056 355.7472)",
    fill: "#fff"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.6588 0l0 65.07l-32.6588 0Z",
    transform: "translate(653.6302 355.7472)",
    fill: "#fff"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l24.5622 0l0 65.07l-24.5622 0Z",
    transform: "translate(687.289 355.7472)",
    fill: "#fff"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l48.703 0l0 28.2925l-48.703 0Z",
    transform: "translate(567.8576 421.8172)",
    fill: "#fff"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l48.703 0l0 26.3717l-48.703 0Z",
    transform: "translate(567.8576 451.1097)",
    fill: "#fff"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l48.703 0l0 24.2003l-48.703 0Z",
    transform: "translate(567.8576 478.4814)",
    fill: "#fff"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l48.703 0l0 22.9163l-48.703 0Z",
    transform: "translate(567.8576 503.6817)",
    fill: "#fff"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.5721 0l0 34.1913l-32.5721 0Z",
    transform: "translate(617.5605 421.8172)",
    fill: "#fff"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.5583 0l0 34.1913l-21.5583 0Z",
    transform: "translate(651.1327 421.8172)",
    fill: "#fff"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l20.4083 0l0 34.1913l-20.4083 0Z",
    transform: "translate(673.691 421.8172)",
    fill: "#fff"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.7518 0l0 34.1913l-16.7518 0Z",
    transform: "translate(695.0993 421.8172)",
    fill: "#fff"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l33.4072 0l0 17.1262l-33.4072 0Z",
    transform: "translate(617.5605 457.0085)",
    fill: "#fff"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l33.4072 0l0 16.9301l-33.4072 0Z",
    transform: "translate(617.5605 475.1346)",
    fill: "#fff"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l33.4072 0l0 16.4476l-33.4072 0Z",
    transform: "translate(617.5605 493.0648)",
    fill: "#fff"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l33.4072 0l0 16.0856l-33.4072 0Z",
    transform: "translate(617.5605 510.5123)",
    fill: "#fff"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.402 0l0 30.4384l-17.402 0Z",
    transform: "translate(651.9678 457.0085)",
    fill: "#fff"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.8866 0l0 30.4384l-13.8866 0Z",
    transform: "translate(670.3697 457.0085)",
    fill: "#fff"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.7546 0l0 30.4384l-13.7546 0Z",
    transform: "translate(685.2564 457.0085)",
    fill: "#fff"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l11.8401 0l0 30.4384l-11.8401 0Z",
    transform: "translate(700.011 457.0085)",
    fill: "#fff"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.5598 0l0 13.098l-27.5598 0Z",
    transform: "translate(651.9678 488.4469)",
    fill: "#fff"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.5598 0l0 12.5166l-27.5598 0Z",
    transform: "translate(651.9678 502.5449)",
    fill: "#fff"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.5598 0l0 10.5364l-27.5598 0Z",
    transform: "translate(651.9678 516.0616)",
    fill: "#fff"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.1746 0l0 19.2417l-15.1746 0Z",
    transform: "translate(680.5275 488.4469)",
    fill: "#fff"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.149 0l0 19.2417l-15.149 0Z",
    transform: "translate(696.7021 488.4469)",
    fill: "#fff"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.4362 0l0 17.9094l-15.4362 0Z",
    transform: "translate(680.5275 508.6886)",
    fill: "#fff"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14.8874 0l0 17.9094l-14.8874 0Z",
    transform: "translate(696.9637 508.6886)",
    fill: "#fff"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l113.7589 0l0 94.5695l-113.7589 0Z",
    transform: "translate(466.5435 531.5979)",
    fill: "#fff"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l52.8277 0l0 49.6146l-52.8277 0Z",
    transform: "translate(581.3024 531.5979)",
    fill: "#fff"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l52.8277 0l0 43.9549l-52.8277 0Z",
    transform: "translate(581.3024 582.2126)",
    fill: "#fff"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l28.9464 0l0 36.71l-28.9464 0Z",
    transform: "translate(635.1301 531.5979)",
    fill: "#fff"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.9372 0l0 36.71l-22.9372 0Z",
    transform: "translate(665.0765 531.5979)",
    fill: "#fff"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.8374 0l0 36.71l-22.8374 0Z",
    transform: "translate(689.0137 531.5979)",
    fill: "#fff"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.1198 0l0 21.2864l-32.1198 0Z",
    transform: "translate(635.1301 569.3079)",
    fill: "#fff"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.1198 0l0 18.0925l-32.1198 0Z",
    transform: "translate(635.1301 591.5943)",
    fill: "#fff"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.1198 0l0 15.4806l-32.1198 0Z",
    transform: "translate(635.1301 610.6868)",
    fill: "#fff"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.6677 0l0 31.5506l-15.6677 0Z",
    transform: "translate(668.2499 569.3079)",
    fill: "#fff"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.6601 0l0 31.5506l-13.6601 0Z",
    transform: "translate(684.9176 569.3079)",
    fill: "#fff"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l12.2735 0l0 31.5506l-12.2735 0Z",
    transform: "translate(699.5776 569.3079)",
    fill: "#fff"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.4091 0l0 12.4043l-29.4091 0Z",
    transform: "translate(668.2499 601.8585)",
    fill: "#fff"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.4091 0l0 10.9046l-29.4091 0Z",
    transform: "translate(668.2499 615.2628)",
    fill: "#fff"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.1921 0l0 24.3089l-13.1921 0Z",
    transform: "translate(698.659 601.8585)",
    fill: "#fff"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l28.0016 0l0 63.9891l-28.0016 0Z",
    transform: "translate(716.8511 355.7472)",
    fill: "#fff"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.332 0l0 63.9891l-25.332 0Z",
    transform: "translate(745.8527 355.7472)",
    fill: "#fff"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.6101 0l0 23.8151l-21.6101 0Z",
    transform: "translate(758.4638 420.7363)",
    fill: "#fff"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.6101 0l0 18.3006l-21.6101 0Z",
    transform: "translate(758.4638 445.5513)",
    fill: "#fff"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l55.6801 0l0 93.7798l-55.6801 0Z",
    transform: "translate(802.0199 355.7472)",
    fill: "#fff"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.712 0l0 24.9077l-21.712 0Z",
    transform: "translate(835.988 450.527)",
    fill: "#fff"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.5252 0l0 58.8186l-22.5252 0Z",
    transform: "translate(716.8511 480.4347)",
    fill: "#fff"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.4257 0l0 58.8186l-22.4257 0Z",
    transform: "translate(740.3763 480.4347)",
    fill: "#fff"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.6195 0l0 43.405l-23.6195 0Z",
    transform: "translate(763.802 480.4347)",
    fill: "#fff"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.6195 0l0 14.4135l-23.6195 0Z",
    transform: "translate(763.802 524.8398)",
    fill: "#fff"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l52.6266 0l0 18.5016l-52.6266 0Z",
    transform: "translate(716.8511 540.2533)",
    fill: "#fff"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.9438 0l0 18.5016l-16.9438 0Z",
    transform: "translate(770.4777 540.2533)",
    fill: "#fff"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.7085 0l0 41.6787l-25.7085 0Z",
    transform: "translate(792.4215 480.4347)",
    fill: "#fff"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.213 0l0 41.6787l-21.213 0Z",
    transform: "translate(819.13 480.4347)",
    fill: "#fff"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.3569 0l0 41.6787l-16.3569 0Z",
    transform: "translate(841.3431 480.4347)",
    fill: "#fff"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l36.6614 0l0 17.7975l-36.6614 0Z",
    transform: "translate(792.4215 523.1134)",
    fill: "#fff"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l36.6614 0l0 16.844l-36.6614 0Z",
    transform: "translate(792.4215 541.9109)",
    fill: "#fff"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.7846 0l0 35.6414l-13.7846 0Z",
    transform: "translate(830.0829 523.1134)",
    fill: "#fff"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l12.8325 0l0 35.6414l-12.8325 0Z",
    transform: "translate(844.8675 523.1134)",
    fill: "#fff"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.4737 0l0 45.6347l-17.4737 0Z",
    transform: "translate(789.833 563.7549)",
    fill: "#fff"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14.3004 0l0 45.6347l-14.3004 0Z",
    transform: "translate(808.3067 563.7549)",
    fill: "#fff"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.9143 0l0 17.2939l-15.9143 0Z",
    transform: "translate(789.833 610.3896)",
    fill: "#fff"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.8598 0l0 17.2939l-15.8598 0Z",
    transform: "translate(806.7473 610.3896)",
    fill: "#fff"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l30.0929 0l0 63.9286l-30.0929 0Z",
    transform: "translate(827.6071 563.7549)",
    fill: "#fff"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l45.6026 0l0 42.3323l-45.6026 0Z",
    transform: "translate(716.8511 632.6835)",
    fill: "#fff"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l45.6026 0l0 34.5842l-45.6026 0Z",
    transform: "translate(716.8511 680.0158)",
    fill: "#fff"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l40.0031 0l0 38.7272l-40.0031 0Z",
    transform: "translate(767.4537 632.6835)",
    fill: "#fff"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l40.0031 0l0 38.1894l-40.0031 0Z",
    transform: "translate(767.4537 676.4106)",
    fill: "#fff"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.8942 0l0 26.8598l-22.8942 0Z",
    transform: "translate(812.4569 632.6835)",
    fill: "#fff"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.8942 0l0 14.4345l-22.8942 0Z",
    transform: "translate(812.4569 660.5433)",
    fill: "#fff"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.3489 0l0 21.2201l-17.3489 0Z",
    transform: "translate(840.3511 632.6835)",
    fill: "#fff"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.3489 0l0 20.0742l-17.3489 0Z",
    transform: "translate(840.3511 654.9036)",
    fill: "#fff"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l218.1905 0l0 307.5572l-218.1905 0Z",
    transform: "translate(95.3 79.4)",
    fill: "rgb(64,95,191)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l147.053 0l0 307.5572l-147.053 0Z",
    transform: "translate(314.4905 79.4)",
    fill: "rgb(58,86,173)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l339.9816 0l0 131.903l-339.9816 0Z",
    transform: "translate(95.3 387.9572)",
    fill: "rgb(57,86,172)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.2619 0l0 119.8485l-25.2619 0Z",
    transform: "translate(436.2816 387.9572)",
    fill: "rgb(46,68,137)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.2619 0l0 11.0545l-25.2619 0Z",
    transform: "translate(436.2816 508.8057)",
    fill: "rgb(45,67,134)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l257.7116 0l0 1.7865l-257.7116 0Z",
    transform: "translate(95.3 520.8602)",
    fill: "rgb(64,95,191)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l107.5319 0l0 1.7865l-107.5319 0Z",
    transform: "translate(354.0116 520.8602)",
    fill: "rgb(54,81,163)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l125.5469 0l0 116.1533l-125.5469 0Z",
    transform: "translate(95.3 527.6467)",
    fill: "rgb(91,158,58)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l125.5469 0l0 69.8l-125.5469 0Z",
    transform: "translate(95.3 644.8)",
    fill: "rgb(91,158,58)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l91.2992 0l0 94.6089l-91.2992 0Z",
    transform: "translate(221.8469 527.6467)",
    fill: "rgb(91,158,58)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l91.2992 0l0 53.7943l-91.2992 0Z",
    transform: "translate(221.8469 623.2556)",
    fill: "rgb(91,158,58)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l91.2992 0l0 36.55l-91.2992 0Z",
    transform: "translate(221.8469 678.05)",
    fill: "rgb(91,158,58)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l50.109 0l0 56.9719l-50.109 0Z",
    transform: "translate(314.1461 527.6467)",
    fill: "rgb(91,158,58)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l49.5332 0l0 56.9719l-49.5332 0Z",
    transform: "translate(365.2551 527.6467)",
    fill: "rgb(91,158,58)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l45.7552 0l0 56.9719l-45.7552 0Z",
    transform: "translate(415.7883 527.6467)",
    fill: "rgb(91,158,58)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l49.4895 0l0 39.0006l-49.4895 0Z",
    transform: "translate(314.1461 585.6185)",
    fill: "rgb(107,186,69)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l49.4895 0l0 31.9459l-49.4895 0Z",
    transform: "translate(314.1461 625.6191)",
    fill: "rgb(91,158,58)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l49.4895 0l0 28.8125l-49.4895 0Z",
    transform: "translate(314.1461 658.565)",
    fill: "rgb(91,158,58)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l49.4895 0l0 26.2225l-49.4895 0Z",
    transform: "translate(314.1461 688.3775)",
    fill: "rgb(91,158,58)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l26.7284 0l0 46.3917l-26.7284 0Z",
    transform: "translate(364.6356 585.6185)",
    fill: "rgb(107,186,69)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.4673 0l0 46.3917l-23.4673 0Z",
    transform: "translate(392.3639 585.6185)",
    fill: "rgb(91,158,58)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.6376 0l0 46.3917l-22.6376 0Z",
    transform: "translate(416.8313 585.6185)",
    fill: "rgb(91,158,58)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.0746 0l0 46.3917l-21.0746 0Z",
    transform: "translate(440.4689 585.6185)",
    fill: "rgb(91,158,58)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l35.1515 0l0 26.3824l-35.1515 0Z",
    transform: "translate(364.6356 633.0102)",
    fill: "rgb(91,158,58)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l35.1515 0l0 20.0079l-35.1515 0Z",
    transform: "translate(364.6356 660.3926)",
    fill: "rgb(91,158,58)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l35.1515 0l0 18.6799l-35.1515 0Z",
    transform: "translate(364.6356 681.4005)",
    fill: "rgb(107,186,69)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l35.1515 0l0 13.5196l-35.1515 0Z",
    transform: "translate(364.6356 701.0804)",
    fill: "rgb(91,158,58)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.4177 0l0 28.4377l-15.4177 0Z",
    transform: "translate(400.7871 633.0102)",
    fill: "rgb(91,158,58)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14.5634 0l0 28.4377l-14.5634 0Z",
    transform: "translate(417.2047 633.0102)",
    fill: "rgb(91,158,58)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14.377 0l0 28.4377l-14.377 0Z",
    transform: "translate(432.7681 633.0102)",
    fill: "rgb(91,158,58)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.3985 0l0 28.4377l-13.3985 0Z",
    transform: "translate(448.1451 633.0102)",
    fill: "rgb(91,158,58)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.0888 0l0 17.0606l-22.0888 0Z",
    transform: "translate(400.7871 662.4479)",
    fill: "rgb(91,158,58)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.0888 0l0 16.9616l-22.0888 0Z",
    transform: "translate(400.7871 680.5085)",
    fill: "rgb(91,158,58)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.0888 0l0 16.1299l-22.0888 0Z",
    transform: "translate(400.7871 698.4701)",
    fill: "rgb(91,158,58)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l12.2766 0l0 27.7223l-12.2766 0Z",
    transform: "translate(423.8758 662.4479)",
    fill: "rgb(91,158,58)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l11.7672 0l0 27.7223l-11.7672 0Z",
    transform: "translate(437.1524 662.4479)",
    fill: "rgb(91,158,58)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l11.6239 0l0 27.7223l-11.6239 0Z",
    transform: "translate(449.9196 662.4479)",
    fill: "rgb(91,158,58)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.3524 0l0 11.4752l-25.3524 0Z",
    transform: "translate(423.8758 691.1701)",
    fill: "rgb(91,158,58)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.3524 0l0 10.9547l-25.3524 0Z",
    transform: "translate(423.8758 703.6453)",
    fill: "rgb(91,158,58)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l11.3153 0l0 23.4299l-11.3153 0Z",
    transform: "translate(450.2283 691.1701)",
    fill: "rgb(91,158,58)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l122.4273 0l0 108.8164l-122.4273 0Z",
    transform: "translate(466.5435 79.4)",
    fill: "rgb(210,147,6)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l72.6555 0l0 108.8164l-72.6555 0Z",
    transform: "translate(589.9708 79.4)",
    fill: "rgb(210,147,6)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l31.2325 0l0 108.8164l-31.2325 0Z",
    transform: "translate(663.6262 79.4)",
    fill: "rgb(210,147,6)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l65.9707 0l0 46.0088l-65.9707 0Z",
    transform: "translate(466.5435 189.2164)",
    fill: "rgb(210,147,6)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l65.9707 0l0 44.6522l-65.9707 0Z",
    transform: "translate(466.5435 236.2252)",
    fill: "rgb(210,147,6)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l65.9707 0l0 36.3652l-65.9707 0Z",
    transform: "translate(466.5435 281.8774)",
    fill: "rgb(210,147,6)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l65.9707 0l0 31.5046l-65.9707 0Z",
    transform: "translate(466.5435 319.2426)",
    fill: "rgb(210,147,6)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.0711 0l0 55.2513l-37.0711 0Z",
    transform: "translate(533.5142 189.2164)",
    fill: "rgb(210,147,6)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l36.2036 0l0 55.2513l-36.2036 0Z",
    transform: "translate(571.5853 189.2164)",
    fill: "rgb(210,147,6)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l33.4255 0l0 55.2513l-33.4255 0Z",
    transform: "translate(608.7889 189.2164)",
    fill: "rgb(210,147,6)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l26.7989 0l0 55.2513l-26.7989 0Z",
    transform: "translate(643.2145 189.2164)",
    fill: "rgb(210,147,6)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.8455 0l0 55.2513l-23.8455 0Z",
    transform: "translate(671.0133 189.2164)",
    fill: "rgb(210,147,6)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l42.6123 0l0 28.1173l-42.6123 0Z",
    transform: "translate(533.5142 245.4677)",
    fill: "rgb(210,147,6)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l42.6123 0l0 27.5102l-42.6123 0Z",
    transform: "translate(533.5142 274.585)",
    fill: "rgb(210,147,6)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l42.6123 0l0 24.2723l-42.6123 0Z",
    transform: "translate(533.5142 303.0953)",
    fill: "rgb(210,147,6)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l42.6123 0l0 22.3796l-42.6123 0Z",
    transform: "translate(533.5142 328.3676)",
    fill: "rgb(210,147,6)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.6395 0l0 24.6226l-37.6395 0Z",
    transform: "translate(577.1265 245.4677)",
    fill: "rgb(210,147,6)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.6395 0l0 21.4248l-37.6395 0Z",
    transform: "translate(577.1265 271.0903)",
    fill: "rgb(210,147,6)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.6395 0l0 19.7185l-37.6395 0Z",
    transform: "translate(577.1265 293.5152)",
    fill: "rgb(210,147,6)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.6395 0l0 17.9986l-37.6395 0Z",
    transform: "translate(577.1265 314.2336)",
    fill: "rgb(248,173,7)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l37.6395 0l0 17.5149l-37.6395 0Z",
    transform: "translate(577.1265 333.2322)",
    fill: "rgb(210,147,6)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l20.0367 0l0 31.5269l-20.0367 0Z",
    transform: "translate(615.766 245.4677)",
    fill: "rgb(210,147,6)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l18.8556 0l0 31.5269l-18.8556 0Z",
    transform: "translate(636.8028 245.4677)",
    fill: "rgb(210,147,6)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l18.7598 0l0 31.5269l-18.7598 0Z",
    transform: "translate(656.6584 245.4677)",
    fill: "rgb(210,147,6)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l18.4406 0l0 31.5269l-18.4406 0Z",
    transform: "translate(676.4182 245.4677)",
    fill: "rgb(210,147,6)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.9446 0l0 18.5958l-29.9446 0Z",
    transform: "translate(615.766 277.9946)",
    fill: "rgb(210,147,6)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.9446 0l0 18.1764l-29.9446 0Z",
    transform: "translate(615.766 297.5903)",
    fill: "rgb(248,173,7)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.9446 0l0 16.8174l-29.9446 0Z",
    transform: "translate(615.766 316.7667)",
    fill: "rgb(210,147,6)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.9446 0l0 16.1631l-29.9446 0Z",
    transform: "translate(615.766 334.5841)",
    fill: "rgb(210,147,6)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.715 0l0 28.7461l-16.715 0Z",
    transform: "translate(646.7106 277.9946)",
    fill: "rgb(210,147,6)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.2664 0l0 28.7461l-15.2664 0Z",
    transform: "translate(664.4256 277.9946)",
    fill: "rgb(210,147,6)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14.1668 0l0 28.7461l-14.1668 0Z",
    transform: "translate(680.692 277.9946)",
    fill: "rgb(210,147,6)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.4263 0l0 15.2667l-25.4263 0Z",
    transform: "translate(646.7106 307.7407)",
    fill: "rgb(210,147,6)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.4263 0l0 12.9288l-25.4263 0Z",
    transform: "translate(646.7106 324.0074)",
    fill: "rgb(210,147,6)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.4263 0l0 12.811l-25.4263 0Z",
    transform: "translate(646.7106 337.9362)",
    fill: "rgb(210,147,6)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l10.4639 0l0 29.2516l-10.4639 0Z",
    transform: "translate(673.1369 307.7407)",
    fill: "rgb(248,173,7)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l10.258 0l0 29.2516l-10.258 0Z",
    transform: "translate(684.6008 307.7407)",
    fill: "rgb(210,147,6)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.7219 0l0 12.7549l-21.7219 0Z",
    transform: "translate(673.1369 337.9923)",
    fill: "rgb(210,147,6)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l157.8412 0l0 128.077l-157.8412 0Z",
    transform: "translate(699.8588 79.4)",
    fill: "rgb(195,22,22)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l74.6145 0l0 54.6669l-74.6145 0Z",
    transform: "translate(699.8588 208.477)",
    fill: "rgb(195,22,22)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l74.6145 0l0 43.6374l-74.6145 0Z",
    transform: "translate(699.8588 264.1439)",
    fill: "rgb(195,22,22)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l74.6145 0l0 41.9659l-74.6145 0Z",
    transform: "translate(699.8588 308.7813)",
    fill: "rgb(195,22,22)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l20.2395 0l0 45.9801l-20.2395 0Z",
    transform: "translate(775.4733 208.477)",
    fill: "rgb(230,25,25)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.4861 0l0 45.9801l-15.4861 0Z",
    transform: "translate(796.7128 208.477)",
    fill: "rgb(209,23,23)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.9072 0l0 45.9801l-22.9072 0Z",
    transform: "translate(813.1989 208.477)",
    fill: "rgb(195,22,22)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l20.5939 0l0 45.9801l-20.5939 0Z",
    transform: "translate(837.1061 208.477)",
    fill: "rgb(195,22,22)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.1822 0l0 39.8826l-23.1822 0Z",
    transform: "translate(775.4733 255.4571)",
    fill: "rgb(195,22,22)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l20.7933 0l0 39.8826l-20.7933 0Z",
    transform: "translate(799.6555 255.4571)",
    fill: "rgb(195,22,22)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l18.3809 0l0 39.8826l-18.3809 0Z",
    transform: "translate(821.4488 255.4571)",
    fill: "rgb(195,22,22)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.8703 0l0 39.8826l-16.8703 0Z",
    transform: "translate(840.8297 255.4571)",
    fill: "rgb(195,22,22)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.4018 0l0 19.0087l-27.4018 0Z",
    transform: "translate(775.4733 296.3397)",
    fill: "rgb(195,22,22)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.4018 0l0 17.0028l-27.4018 0Z",
    transform: "translate(775.4733 316.3484)",
    fill: "rgb(230,25,25)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.4018 0l0 16.396l-27.4018 0Z",
    transform: "translate(775.4733 334.3512)",
    fill: "rgb(230,25,25)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.921 0l0 21.9751l-17.921 0Z",
    transform: "translate(803.8751 296.3397)",
    fill: "rgb(195,22,22)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.2541 0l0 21.9751l-17.2541 0Z",
    transform: "translate(822.796 296.3397)",
    fill: "rgb(230,25,25)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.6498 0l0 21.9751l-16.6498 0Z",
    transform: "translate(841.0502 296.3397)",
    fill: "rgb(195,22,22)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.2535 0l0 15.305l-23.2535 0Z",
    transform: "translate(803.8751 319.3148)",
    fill: "rgb(195,22,22)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.2535 0l0 15.1274l-23.2535 0Z",
    transform: "translate(803.8751 335.6198)",
    fill: "rgb(195,22,22)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.7781 0l0 21.4568l-15.7781 0Z",
    transform: "translate(828.1285 319.3148)",
    fill: "rgb(195,22,22)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l12.7934 0l0 21.4568l-12.7934 0Z",
    transform: "translate(844.9066 319.3148)",
    fill: "rgb(195,22,22)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.5715 0l0 8.9756l-29.5715 0Z",
    transform: "translate(828.1285 341.7716)",
    fill: "rgb(195,22,22)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l100.314 0l0 85.0534l-100.314 0Z",
    transform: "translate(466.5435 355.7472)",
    fill: "rgb(41,138,175)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l100.314 0l0 84.7974l-100.314 0Z",
    transform: "translate(466.5435 441.8006)",
    fill: "rgb(41,138,175)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l44.148 0l0 65.07l-44.148 0Z",
    transform: "translate(567.8576 355.7472)",
    fill: "rgb(41,138,175)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l39.6246 0l0 65.07l-39.6246 0Z",
    transform: "translate(613.0056 355.7472)",
    fill: "rgb(41,138,175)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.6588 0l0 65.07l-32.6588 0Z",
    transform: "translate(653.6302 355.7472)",
    fill: "rgb(41,138,175)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l24.5622 0l0 65.07l-24.5622 0Z",
    transform: "translate(687.289 355.7472)",
    fill: "rgb(41,138,175)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l48.703 0l0 28.2925l-48.703 0Z",
    transform: "translate(567.8576 421.8172)",
    fill: "rgb(41,138,175)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l48.703 0l0 26.3717l-48.703 0Z",
    transform: "translate(567.8576 451.1097)",
    fill: "rgb(41,138,175)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l48.703 0l0 24.2003l-48.703 0Z",
    transform: "translate(567.8576 478.4814)",
    fill: "rgb(41,138,175)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l48.703 0l0 22.9163l-48.703 0Z",
    transform: "translate(567.8576 503.6817)",
    fill: "rgb(41,138,175)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.5721 0l0 34.1913l-32.5721 0Z",
    transform: "translate(617.5605 421.8172)",
    fill: "rgb(41,138,175)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.5583 0l0 34.1913l-21.5583 0Z",
    transform: "translate(651.1327 421.8172)",
    fill: "rgb(41,138,175)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l20.4083 0l0 34.1913l-20.4083 0Z",
    transform: "translate(673.691 421.8172)",
    fill: "rgb(41,138,175)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.7518 0l0 34.1913l-16.7518 0Z",
    transform: "translate(695.0993 421.8172)",
    fill: "rgb(41,138,175)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l33.4072 0l0 17.1262l-33.4072 0Z",
    transform: "translate(617.5605 457.0085)",
    fill: "rgb(41,138,175)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l33.4072 0l0 16.9301l-33.4072 0Z",
    transform: "translate(617.5605 475.1346)",
    fill: "rgb(41,138,175)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l33.4072 0l0 16.4476l-33.4072 0Z",
    transform: "translate(617.5605 493.0648)",
    fill: "rgb(41,138,175)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l33.4072 0l0 16.0856l-33.4072 0Z",
    transform: "translate(617.5605 510.5123)",
    fill: "rgb(41,138,175)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.402 0l0 30.4384l-17.402 0Z",
    transform: "translate(651.9678 457.0085)",
    fill: "rgb(41,138,175)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.8866 0l0 30.4384l-13.8866 0Z",
    transform: "translate(670.3697 457.0085)",
    fill: "rgb(41,138,175)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.7546 0l0 30.4384l-13.7546 0Z",
    transform: "translate(685.2564 457.0085)",
    fill: "rgb(41,138,175)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l11.8401 0l0 30.4384l-11.8401 0Z",
    transform: "translate(700.011 457.0085)",
    fill: "rgb(41,138,175)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.5598 0l0 13.098l-27.5598 0Z",
    transform: "translate(651.9678 488.4469)",
    fill: "rgb(41,138,175)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.5598 0l0 12.5166l-27.5598 0Z",
    transform: "translate(651.9678 502.5449)",
    fill: "rgb(41,138,175)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l27.5598 0l0 10.5364l-27.5598 0Z",
    transform: "translate(651.9678 516.0616)",
    fill: "rgb(41,138,175)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.1746 0l0 19.2417l-15.1746 0Z",
    transform: "translate(680.5275 488.4469)",
    fill: "rgb(41,138,175)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.149 0l0 19.2417l-15.149 0Z",
    transform: "translate(696.7021 488.4469)",
    fill: "rgb(41,138,175)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.4362 0l0 17.9094l-15.4362 0Z",
    transform: "translate(680.5275 508.6886)",
    fill: "rgb(41,138,175)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14.8874 0l0 17.9094l-14.8874 0Z",
    transform: "translate(696.9637 508.6886)",
    fill: "rgb(41,138,175)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l113.7589 0l0 94.5695l-113.7589 0Z",
    transform: "translate(466.5435 531.5979)",
    fill: "rgb(58,159,112)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l52.8277 0l0 49.6146l-52.8277 0Z",
    transform: "translate(581.3024 531.5979)",
    fill: "rgb(58,159,112)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l52.8277 0l0 43.9549l-52.8277 0Z",
    transform: "translate(581.3024 582.2126)",
    fill: "rgb(58,159,112)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l28.9464 0l0 36.71l-28.9464 0Z",
    transform: "translate(635.1301 531.5979)",
    fill: "rgb(58,159,112)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.9372 0l0 36.71l-22.9372 0Z",
    transform: "translate(665.0765 531.5979)",
    fill: "rgb(58,159,112)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.8374 0l0 36.71l-22.8374 0Z",
    transform: "translate(689.0137 531.5979)",
    fill: "rgb(58,159,112)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.1198 0l0 21.2864l-32.1198 0Z",
    transform: "translate(635.1301 569.3079)",
    fill: "rgb(58,159,112)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.1198 0l0 18.0925l-32.1198 0Z",
    transform: "translate(635.1301 591.5943)",
    fill: "rgb(58,159,112)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l32.1198 0l0 15.4806l-32.1198 0Z",
    transform: "translate(635.1301 610.6868)",
    fill: "rgb(58,159,112)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.6677 0l0 31.5506l-15.6677 0Z",
    transform: "translate(668.2499 569.3079)",
    fill: "rgb(58,159,112)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.6601 0l0 31.5506l-13.6601 0Z",
    transform: "translate(684.9176 569.3079)",
    fill: "rgb(58,159,112)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l12.2735 0l0 31.5506l-12.2735 0Z",
    transform: "translate(699.5776 569.3079)",
    fill: "rgb(58,159,112)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.4091 0l0 12.4043l-29.4091 0Z",
    transform: "translate(668.2499 601.8585)",
    fill: "rgb(58,159,112)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l29.4091 0l0 10.9046l-29.4091 0Z",
    transform: "translate(668.2499 615.2628)",
    fill: "rgb(58,159,112)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.1921 0l0 24.3089l-13.1921 0Z",
    transform: "translate(698.659 601.8585)",
    fill: "rgb(58,159,112)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l28.0016 0l0 63.9891l-28.0016 0Z",
    transform: "translate(716.8511 355.7472)",
    fill: "rgb(145,82,173)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.332 0l0 63.9891l-25.332 0Z",
    transform: "translate(745.8527 355.7472)",
    fill: "rgb(101,57,121)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.6101 0l0 23.8151l-21.6101 0Z",
    transform: "translate(758.4638 420.7363)",
    fill: "rgb(145,82,173)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.6101 0l0 18.3006l-21.6101 0Z",
    transform: "translate(758.4638 445.5513)",
    fill: "rgb(101,57,121)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l55.6801 0l0 93.7798l-55.6801 0Z",
    transform: "translate(802.0199 355.7472)",
    fill: "rgb(187,30,144)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.712 0l0 24.9077l-21.712 0Z",
    transform: "translate(835.988 450.527)",
    fill: "rgb(220,35,169)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.5252 0l0 58.8186l-22.5252 0Z",
    transform: "translate(716.8511 480.4347)",
    fill: "rgb(64,95,191)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.4257 0l0 58.8186l-22.4257 0Z",
    transform: "translate(740.3763 480.4347)",
    fill: "rgb(45,67,134)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.6195 0l0 43.405l-23.6195 0Z",
    transform: "translate(763.802 480.4347)",
    fill: "rgb(64,95,191)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l23.6195 0l0 14.4135l-23.6195 0Z",
    transform: "translate(763.802 524.8398)",
    fill: "rgb(51,76,154)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l52.6266 0l0 18.5016l-52.6266 0Z",
    transform: "translate(716.8511 540.2533)",
    fill: "rgb(64,95,191)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.9438 0l0 18.5016l-16.9438 0Z",
    transform: "translate(770.4777 540.2533)",
    fill: "rgb(51,76,153)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l25.7085 0l0 41.6787l-25.7085 0Z",
    transform: "translate(792.4215 480.4347)",
    fill: "rgb(91,158,58)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l21.213 0l0 41.6787l-21.213 0Z",
    transform: "translate(819.13 480.4347)",
    fill: "rgb(91,158,58)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l16.3569 0l0 41.6787l-16.3569 0Z",
    transform: "translate(841.3431 480.4347)",
    fill: "rgb(91,158,58)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l36.6614 0l0 17.7975l-36.6614 0Z",
    transform: "translate(792.4215 523.1134)",
    fill: "rgb(91,158,58)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l36.6614 0l0 16.844l-36.6614 0Z",
    transform: "translate(792.4215 541.9109)",
    fill: "rgb(91,158,58)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l13.7846 0l0 35.6414l-13.7846 0Z",
    transform: "translate(830.0829 523.1134)",
    fill: "rgb(91,158,58)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l12.8325 0l0 35.6414l-12.8325 0Z",
    transform: "translate(844.8675 523.1134)",
    fill: "rgb(91,158,58)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.4737 0l0 45.6347l-17.4737 0Z",
    transform: "translate(789.833 563.7549)",
    fill: "rgb(195,22,22)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14.3004 0l0 45.6347l-14.3004 0Z",
    transform: "translate(808.3067 563.7549)",
    fill: "rgb(195,22,22)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.9143 0l0 17.2939l-15.9143 0Z",
    transform: "translate(789.833 610.3896)",
    fill: "rgb(195,22,22)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l15.8598 0l0 17.2939l-15.8598 0Z",
    transform: "translate(806.7473 610.3896)",
    fill: "rgb(195,22,22)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l30.0929 0l0 63.9286l-30.0929 0Z",
    transform: "translate(827.6071 563.7549)",
    fill: "rgb(49,162,206)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l45.6026 0l0 42.3323l-45.6026 0Z",
    transform: "translate(716.8511 632.6835)",
    fill: "rgb(58,159,112)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l45.6026 0l0 34.5842l-45.6026 0Z",
    transform: "translate(716.8511 680.0158)",
    fill: "rgb(213,65,4)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l40.0031 0l0 38.7272l-40.0031 0Z",
    transform: "translate(767.4537 632.6835)",
    fill: "rgb(123,69,147)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l40.0031 0l0 38.1894l-40.0031 0Z",
    transform: "translate(767.4537 676.4106)",
    fill: "rgb(187,30,144)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.8942 0l0 26.8598l-22.8942 0Z",
    transform: "translate(812.4569 632.6835)",
    fill: "rgb(54,81,163)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l22.8942 0l0 14.4345l-22.8942 0Z",
    transform: "translate(812.4569 660.5433)",
    fill: "rgb(64,95,191)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.3489 0l0 21.2201l-17.3489 0Z",
    transform: "translate(840.3511 632.6835)",
    fill: "rgb(107,186,69)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l17.3489 0l0 20.0742l-17.3489 0Z",
    transform: "translate(840.3511 654.9036)",
    fill: "rgb(107,186,69)"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(204.3953 233.1786)",
    fill: "#fff"
  }, "Ting-Ting.SpeechVoice"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(388.017 233.1786)",
    fill: "#fff"
  }, "Alex.SpeechVoice"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(265.2908 453.9087)",
    fill: "#fff"
  }, "Kyoko.SpeechVoice"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(448.9126 447.8815)",
    fill: "#fff"
  }, "Vi"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(158.0734 585.7233)",
    fill: "#fff"
  }, "Versions"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(158.0734 679.7)",
    fill: "#fff"
  }, "Versions"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(267.4965 574.9512)",
    fill: "#fff"
  }, "Versions"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(267.4965 650.1528)",
    fill: "#fff"
  }, "Versions"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(267.4965 696.325)",
    fill: "#fff"
  }, "Versions"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(339.2006 556.1326)",
    fill: "#fff"
  }, "Versi..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(390.0217 556.1326)",
    fill: "#fff"
  }, "Versi..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(438.6659 556.1326)",
    fill: "#fff"
  }, "Vers..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(338.8908 605.1188)",
    fill: "#fff"
  }, "Versi..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(338.8908 641.5921)",
    fill: "#fff"
  }, "Versi..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(338.8908 672.9713)",
    fill: "#fff"
  }, "Versi..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(338.8908 701.4888)",
    fill: "#fff"
  }, "Versi..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(377.9998 608.8144)",
    fill: "#fff"
  }, "Ve"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(404.0976 608.8144)",
    fill: "#fff"
  }, "V"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(428.1501 608.8144)",
    fill: "#fff"
  }, "V"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(451.0062 608.8144)",
    fill: "#fff"
  }, "V"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(382.2113 646.2014)",
    fill: "#fff"
  }, "Ve..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(527.7572 133.8082)",
    fill: "#fff"
  }, "Versions"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(626.2985 133.8082)",
    fill: "#fff"
  }, "Versions"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(679.2425 133.8082)",
    fill: "#fff"
  }, "Ver"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(499.5289 212.2208)",
    fill: "#fff"
  }, "Versions"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(499.5289 258.5513)",
    fill: "#fff"
  }, "Versions"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(499.5289 300.06)",
    fill: "#fff"
  }, "Versions"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(499.5289 334.9949)",
    fill: "#fff"
  }, "Versions"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(552.0498 216.842)",
    fill: "#fff"
  }, "Ve..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(589.6871 216.842)",
    fill: "#fff"
  }, "Ve..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(625.5017 216.842)",
    fill: "#fff"
  }, "Ver"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(656.6139 216.842)",
    fill: "#fff"
  }, "Ve"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(682.9361 216.842)",
    fill: "#fff"
  }, "V"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(554.8204 259.5264)",
    fill: "#fff"
  }, "Ver..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(554.8204 288.3402)",
    fill: "#fff"
  }, "Ver..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(554.8204 315.2314)",
    fill: "#fff"
  }, "Ver..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(554.8204 339.5574)",
    fill: "#fff"
  }, "Ver..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(595.9463 257.779)",
    fill: "#fff"
  }, "Ve..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(625.7844 261.2311)",
    fill: "#fff"
  }, "V"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(646.2306 261.2311)",
    fill: "#fff"
  }, "V"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(666.0383 261.2311)",
    fill: "#fff"
  }, "V"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(685.6385 261.2311)",
    fill: "#fff"
  }, "V"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(778.7794 143.4385)",
    fill: "#fff"
  }, "Contents"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(737.166 235.8105)",
    fill: "#fff"
  }, "Contents"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(737.166 285.9626)",
    fill: "#fff"
  }, "Contents"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(737.166 329.7642)",
    fill: "#fff"
  }, "Contents"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(785.593 231.4671)",
    fill: "#fff"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(824.6525 231.4671)",
    fill: "#fff"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(847.403 231.4671)",
    fill: "#fff"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(787.0644 275.3984)",
    fill: "#fff"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(810.0522 275.3984)",
    fill: "#fff"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(516.7006 398.2739)",
    fill: "#fff"
  }, "Contents"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(516.7006 484.1993)",
    fill: "#fff"
  }, "Contents"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(589.9316 388.2822)",
    fill: "#fff"
  }, "Con..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(632.8179 388.2822)",
    fill: "#fff"
  }, "Co..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(669.9596 388.2822)",
    fill: "#fff"
  }, "Con"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(699.57 388.2822)",
    fill: "#fff"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(592.209 435.9634)",
    fill: "#fff"
  }, "Cont..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(592.209 464.2955)",
    fill: "#fff"
  }, "Cont..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(592.209 490.5815)",
    fill: "#fff"
  }, "Cont..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(592.209 515.1398)",
    fill: "#fff"
  }, "Cont..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(633.8466 438.9128)",
    fill: "#fff"
  }, "Con"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(661.9118 438.9128)",
    fill: "#fff"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(683.8952 438.9128)",
    fill: "#fff"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(523.423 578.8827)",
    fill: "#fff"
  }, "Contents"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(607.7163 556.4053)",
    fill: "#fff"
  }, "Cont..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(607.7163 604.19)",
    fill: "#fff"
  }, "Cont..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(649.6033 549.9529)",
    fill: "#fff"
  }, "Co"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(676.5451 549.9529)",
    fill: "#fff"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(700.4324 549.9529)",
    fill: "#fff"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(589.1973 672.8837)",
    fill: "#fff"
  }, "Fonts"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(730.8519 387.7417)",
    fill: "#fff"
  }, "Ha"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(758.5187 387.7417)",
    fill: "#fff"
  }, "H"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(784.6023 387.7417)",
    fill: "#fff"
  }, "de"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(737.1574 435.5029)",
    fill: "#fff"
  }, "fr"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(737.1574 463.3521)",
    fill: "#fff"
  }, "es"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(769.2688 432.6438)",
    fill: "#fff"
  }, "G"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(789.0469 442.2941)",
    fill: "#fff"
  }, "i"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(829.86 402.6371)",
    fill: "#fff"
  }, "1.6.0...."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(818.504 462.9809)",
    fill: "#fff"
  }, "Ext"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(846.844 462.9809)",
    fill: "#fff"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(728.1137 509.844)",
    fill: "#fff"
  }, "5."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(751.5891 509.844)",
    fill: "#fff"
  }, "5."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(775.6117 502.1373)",
    fill: "#fff"
  }, "d"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(805.2758 501.2741)",
    fill: "#fff"
  }, "Co"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(829.7365 501.2741)",
    fill: "#fff"
  }, "C"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(750.8421 595.7192)",
    fill: "#fff"
  }, "Composi..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(842.6536 595.7192)",
    fill: "#fff"
  }, "Sta"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(739.6524 653.8496)",
    fill: "#fff"
  }, "Con..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(739.6524 697.3079)",
    fill: "#fff"
  }, "Con..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(787.4553 652.0471)",
    fill: "#fff"
  }, "Co..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(787.4553 695.5053)",
    fill: "#fff"
  }, "Co..."), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(823.904 646.1134)",
    fill: "#fff"
  }, "C"), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 77.4 0 77.4 22 0 22",
    transform: "translate(437.8232 772)",
    fill: "rgb(0,0,0)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    xmlSpace: "preserve",
    transform: "translate(476.5 783)",
    fill: "#fff"
  }, "Disk Usage"), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M-53.5244 -5l107.0488 0l0 28l-107.0488 0Z",
    transform: "translate(476.5 5)",
    fill: "rgb(0,0,0)",
    fillOpacity: 0,
    stroke: "#ccc",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 18,
      fontFamily: "sans-serif",
      fontWeight: "bold"
    },
    xmlSpace: "preserve",
    y: 9,
    transform: "translate(476.5 5)",
    fill: "#464646"
  }, "Disk Usage"));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreemapchartThumb);
export default __webpack_public_path__ + "static/media/treemapchart_thumb.e2276b215e6ed936b537fa30db5092c1.svg";
export { ForwardRef as ReactComponent };